import { Component, Input } from '@angular/core';
import { RequiredFieldsNoteDirective } from './required-fields-note.directive';

@Component({
	selector: 'ngx-required-fields-note',
	template: `
		<div [goRequiredFieldsNote]="noteTranslationKey"></div>
	`,
	standalone: true,
	imports: [RequiredFieldsNoteDirective]
})
export class RequiredFieldsNoteComponent {
	@Input() public noteTranslationKey = 'common_required-fields-note';
}
